<template>
  <base-container :isLoading="isLoading">
    <div class="artisan-base">
      <h2 class="artisan-center">修改密码</h2>
      <van-form @submit="onSubmit" :show-error-message="false" style="margin-top: 16px;">
        <van-field
          style="border-radius:999px;margin-top:12px;padding-bottom:5px;"
          v-model="data.oldPwd"
          label-width="2rem"
          type="password"
          label="密码"
          placeholder="密码"
          :rules="[{ required: true, message: '请填写密码' }]"
        >
          <template #label>
            <van-image
              style="margin:3px 5px"
              width="17"
              height="17"
              :src="require('@/assets/img/lock.png')"
            />
          </template>
        </van-field>
        <van-field
          style="border-radius:999px;margin-top:12px;padding-bottom:5px;"
          v-model="data.newPwd"
          label-width="2rem"
          type="password"
          label="新密码"
          placeholder="新密码"
          :rules="[{ required: true, message: '请填写新密码',pattern:/^[\w_-]{6,16}$/ }]"
        >
          <template #label>
            <van-image
              style="margin:3px 5px"
              width="17"
              height="17"
              :src="require('@/assets/img/lock.png')"
            />
          </template>
        </van-field>
        <van-field
          style="border-radius:999px;margin-top:12px;padding-bottom:5px;"
          v-model="data.confirmPwd"
          label-width="2rem"
          type="password"
          label="确认密码"
          placeholder="确认密码"
          :rules="[{ required: true, message: '请再次填写新密码',pattern:/^[\w_-]{6,16}$/  }]"
        >
          <template #label>
            <van-image
              style="margin:3px 5px"
              width="17"
              height="17"
              :src="require('@/assets/img/lock.png')"
            />
          </template>
        </van-field>
        <div style="margin-top: 16px;">
          <van-button class="artisan-btn" round block type="info" native-type="submit">修改</van-button>
        </div>
      </van-form>
    </div>
  </base-container>
</template>

<script>
import { editPwd } from "@/api/auth";
import { logout } from "@/util/auth";
import { Dialog, Toast } from "vant";
export default {
  data() {
    return {
      isLoading: false,
      data: {
        oldPwd: "",
        newPwd: "",
        confirmPwd: "",
      },
    };
  },
  methods: {
    onSubmit() {
      if (this.data.newPwd != this.data.confirmPwd) {
        Toast.fail("两次输入的新密码不一致！");
        return;
      }
      Dialog.confirm({
        title: "提示",
        message: "确认修改密码？",
      }).then(() => {
        this.isLoading = true;
        editPwd(this.data)
          .then(() => {
            this.isLoading = false;
            logout();
            Dialog.confirm({
              title: "密码修改成功！",
              message: "是否前往登录",
            }).then(() => {
              this.$router.push("/login");
            });
          })
          .catch(() => {
            this.isLoading = false;
          });
      });
    },
  },
};
</script>

<style>
</style>